export default "__VITE_ASSET__DBmCOMWC__"